import React from 'react';

import './LegendTooltipContent.theme.scss';

const LegendTooltipContent = () => (
  <div className="legend-tooltip">
    <div className="legend-tooltip__title">Legend</div>
    <div className="legend-tooltip__routes">
      <div className="legend-tooltip__route-icon legend-tooltip__route-icon--published" />
      <div>Published route</div>
      <div className="legend-tooltip__route-icon legend-tooltip__route-icon--predicted" />
      <div>Predicted route</div>
      <div className="legend-tooltip__route-icon legend-tooltip__route-icon--customized" />
      <div>Customized route</div>
    </div>
    <hr />
    <div className="legend-tooltip__commercially-available">
      <div className="legend-tooltip__commercially-available--rect" />
      Commercially available compound
    </div>
  </div>
);

export default LegendTooltipContent;
